import { pick } from "radash";

import { getClientSideArgusProjection } from "@/client/argusProjection";
import { createArgusEvent } from "@/client/createArgusEvent";
import { createGtmEvent } from "@/client/gtm/gtm";

import type { MarketingParams } from "./marketingParamsParser";

import {
  getMarketingParamsFromUrl,
  hasMarketingParams,
} from "./marketingParamsParser";

function addMarketingParamsEvent(marketingParams: MarketingParams) {
  if (!hasMarketingParams(marketingParams)) {
    return;
  }

  return createArgusEvent("marketing_params", marketingParams);
}

function addMarketingParamsEventFromReferrer() {
  if (!document.referrer) {
    return;
  }
  return addMarketingParamsEvent(
    getMarketingParamsFromUrl(new URL(document.referrer)),
  );
}

function addMarketingParamsEventFromUrl() {
  return addMarketingParamsEvent(getMarketingParamsFromUrl());
}

function addMarketingParamsGtmEvent() {
  const projection = getClientSideArgusProjection();
  if (!hasMarketingParams(projection)) {
    return;
  }

  return createGtmEvent(
    "marketing_params",
    pick(projection, [
      "utmSource",
      "utmMedium",
      "utmCampaign",
      "utmTerm",
      "utmContent",
      "fbclid",
      "gclid",
      "seaPlatform",
      "seaCampaignId",
      "seaAdGroupId",
      "seaAdId",
      "seaClickId",
    ]),
  );
}

export type { MarketingParams };

export {
  addMarketingParamsEventFromReferrer,
  addMarketingParamsEventFromUrl,
  addMarketingParamsGtmEvent,
  getMarketingParamsFromUrl,
};
